import React from 'react'
import {Fragment} from "react";

export function Text(props){
	return props.text
}

Text.defaultProps = {
	text: 'NO TEXT'
}

export function Italics(props){
	return <i><Text text={props.text}/></i>
}

export function Emphasized(props){
	return <strong><Italics text={props.text}/></strong>
}

export function OtherPresent(props){
	return (
		<Fragment>
			<Italics text={props.text}/>
			<Text text={' other'}/>
		</Fragment>
	)
}